import axios from 'axios';
import { message } from 'ant-design-vue';
import { generateSignHeaders, mapSignErrorMsg } from '@/utils/sign';
import { encryptBody, ENABLE_CRYPTO } from '@/utils/encrypt';
// 创建 axios 实例
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://api.example.com', // API 基础路径
    timeout: 10000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json',
    },
});

// 请求拦截器
apiClient.interceptors.request.use(
    config => {
        config.headers['token'] = localStorage.getItem("token");
        config.headers['tenantId'] = 1;
        // 追加签名头（每次请求现场生成）
        const signHeaders = generateSignHeaders();
        Object.keys(signHeaders).forEach(k => {
            config.headers[k] = signHeaders[k];
        });
        // 请求体加密：仅加密非 GET、非 FormData、非 URLSearchParams 的 JSON 请求
        const method = (config.method || 'get').toLowerCase();
        const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
        const isUrlSearchParams = typeof URLSearchParams !== 'undefined' && config.data instanceof URLSearchParams;
        if (ENABLE_CRYPTO && method !== 'get' && !isFormData && !isUrlSearchParams) {
            let payload = config.data;
            // 业务代码可能已手动 JSON.stringify，先转回对象避免双重序列化
            if (typeof payload === 'string') {
                try {
                    payload = JSON.parse(payload);
                } catch (e) {
                    // 非 JSON 字符串则保持原样
                }
            }
            // 无参数时也加密空对象 {}，不发送空 body
            config.data = encryptBody(payload || {});
            config.headers['Content-Type'] = 'application/json';
        }
        return config;
    },
    error => {
        // 请求错误时的处理
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
apiClient.interceptors.response.use(
    response => {
        // 对响应数据进行处理
        switch (response.data.code) {
            case 401:
                // 处理未授权错误，如跳转到登录页面
                message.error(' 请登录!');
                window.localStorage.clear();
                window.location.href = '/login'
                return response.data;
            case 403:
                //缺少权限
                window.location.href = '/error?code=' + response.data.code + "&msg=" + response.data.msg;
                return response.data;
            case 601:
                //用户锁定
                window.location.href = '/error?code=' + response.data.code + "&msg=" + response.data.msg;
                window.localStorage.clear();
                return response.data;
            case 500: {
                // 处理服务器错误（签名校验类错误优先映射为友好提示）
                const signTip = mapSignErrorMsg(response.data.msg);
                if (signTip) {
                    message.error(signTip);
                } else if (!(response.config && response.config.silent)) {
                    // 业务错误（后端 SaResult.error 也是 500）由调用方自行展示 msg，
                    // 携带 silent 时跳过统一提示，避免同一错误弹两条
                    message.error(response.data.code + ' 请求错误：' + response.data.msg);
                }
                return response.data;
            }
            default:
                return response.data;
        }
    },
    error => {
        // 处理响应错误
        if (error.response) {
            message.error('请求错误：' + error.response);
        } else if (error.request) {
            message.error('网络异常' + error.response);
        } else {
            message.error('意外的错误：' + error.message);
        }
        return Promise.reject(error);
    }
);

// API 请求函数

//获取用户信息
export function getInfoBytoken() {
    return apiClient.get('users/getInfoBytoken');
}

//修改用户密码
export function updatePasByoldPas(data) {
    return apiClient.post('users/updatePasByoldPas', data);
}


//修改用户信息
export function updateUsByToken(data) {
    return apiClient.post('users/updateUsByToken', data);
}


//获取菜单列表
export function menuPage(data) {
    return apiClient.get('menus/page', {
        params: data,
    });
}

//查询父级菜单
export function listParentMenus() {
    return apiClient.get('menus/listParent');
}


//修改菜单
export function updateMenus(data) {
    return apiClient.put('menus/update', data);
}

//删除菜单
export function removeMenu(data) {
    return apiClient.delete('menus/remove/' + data);
}

//添加菜单
export function saveMenus(data) {
    return apiClient.post('menus/save', data);
}

//获取个人通知
export function listUniRead(data) {
    return apiClient.get('announce/listUniRead', {
        params: data,
    });
}

//获取部门列表
export function deptPage(data) {
    return apiClient.get('dept/page', {
        params: data,
    });
}

//修改部门
export function updateDepts(data) {
    return apiClient.put('dept/update', data);
}

//删除部门
export function removeDept(data) {
    return apiClient.delete('dept/remove/' + data);
}

//添加部门
export function saveDepts(data) {
    return apiClient.post('dept/save', data);
}

//查询父级部门
export function listParentDepts() {
    return apiClient.get('dept/listParent');
}

//查询所有部门集合
export function listDepts() {
    return apiClient.get('dept/list');
}

//查询所有部门树形结构
export function treeDepts() {
    return apiClient.get('dept/tree');
}

//查询所有部门集合
export function listPermissions() {
    return apiClient.get('permissions/list');
}

//获取所有用户
export function userLists(data) {
    return apiClient.get('users/list', {
        params: data,
    });
}

//获取用户列表
export function userPage(data) {
    return apiClient.get('users/page', {
        params: data,
    });
}

//修改用户
export function updateUsers(data) {
    return apiClient.put('users/update', data);
}

//删除用户
export function removeUser(data) {
    return apiClient.delete('users/remove/' + data);
}

//添加用户
export function saveUsers(data) {
    return apiClient.post('users/save', data);
}

//重置密码
export function resetPasswordUser(data) {
    return apiClient.post('users/resetPasswordUser', data);
}

//获取权限列表
export function promisePage(data) {
    return apiClient.get('permissions/page', {
        params: data,
    });
}


//修改权限
export function updatePromise(data) {
    return apiClient.put('permissions/update', data);
}

//删除权限
export function removePermissions(data) {
    return apiClient.delete('permissions/remove/' + data);
}

//添加权限
export function savePermissions(data) {
    return apiClient.post('permissions/save', data);
}

//获取权限配置
export function menuPermissions(data) {
    return apiClient.get('menuPermissions/list', {
        params: data,
    });
}

//设置权限配置
export function updatePermissions(data) {
    return apiClient.put('menuPermissions/update', data);
}


//获取租户列表
export function tenantPage(data) {
    return apiClient.get('tenant/page', {
        params: data,
    });
}


//修改租户
export function updateTenant(data) {
    return apiClient.put('tenant/update', data);
}

//删除租户
export function removeTenant(data) {
    return apiClient.delete('tenant/remove/' + data);
}

//添加租户
export function saveTenant(data) {
    return apiClient.post('tenant/save', data);
}

//上传头像
export function pushAvatar(data) {
    return apiClient.post('common/uploadAvatar', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

//读取文件（图片等），以 blob 方式走统一请求层，确保携带签名头
export function readFileBlob(path) {
    return apiClient.get('common/readFile', {
        params: { path },
        responseType: 'blob',
    });
}


//获取通知列表
export function announcePage(data) {
    return apiClient.get('announce/page', {
        params: data,
    });
}

//添加通知
export function saveAnnounce(data) {
    return apiClient.post('announce/save', data);
}

//删除通知
export function removeAnnounce(data) {
    return apiClient.delete('announce/remove/' + data);
}

//获取通知详情
export function announce(data) {
    return apiClient.get('announce/' + data);
}

//设置已读
export function setRead(data) {
    return apiClient.get('/announce/setRead/' + data);
}

//上传通告文件
export function pushAnnFile(data) {
    return apiClient.post('common/uploadAnnFile', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}


//获取设置列表
export function setPage(data) {
    return apiClient.get('set/page', {
        params: data,
    });
}


//修改设置
export function updateSet(data) {
    return apiClient.put('set/update', data);
}

//删除设置
export function removeSet(data) {
    return apiClient.delete('set/remove/' + data);
}

//添加设置
export function saveSet(data) {
    return apiClient.post('set/save', data);
}


//获取日志列表
export function logPage(data) {
    return apiClient.get('logs/page', {
        params: data,
    });
}

//获取日志详情
export function logs(data) {
    return apiClient.get('logs/getInfo/' + data);
}


// 下载文件，设置响应头和请求头
export function downAnnFile(data) {
    return apiClient.get('common/downFile', {
        params: data,
        responseType: 'blob', // 处理二进制文件
    }).then((response) => {
        // 提取文件名
        const fileName = data.path.split('/').pop();
        console.log('内容', response);
        // 处理下载文件
        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    }).catch((error) => {
        console.error('下载文件失败', error);
    });
}

//获取案例列表
export function taxCasePage(data) {
    return apiClient.get('/sveTaxCase/page', {
        params: data,
    });
}

//添加案例
export function saveTaxCase(data) {
    return apiClient.post('/sveTaxCase/save', data);
}

//修改案例
export function updateTaxCase(data) {
    return apiClient.put('/sveTaxCase/update', data);
}

//删除案例
export function removeTaxCase(data) {
    return apiClient.delete('/sveTaxCase/remove/' + data);
}

//获取案例详情
export function getTaxCaseInfo(id) {
    return apiClient.get('/sveTaxCase/getInfo/' + id);
}

//根据案例编号查询案例信息
export function getCaseByCaseNo(caseNo) {
    return apiClient.get('/sveTaxCase/listByCaseNo', {
        params: { CaseNo: caseNo },
    });
}

//导入案例
export function importTaxCase(formData) {
    return apiClient.post('/sveTaxCase/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

//行业列表
export function industryList() {
    return apiClient.get('/sveIndustryType/list');
}

//行业分页
export function industryPage(data) {
    return apiClient.get('/sveIndustryType/page', {
        params: data,
    });
}

//添加行业
export function saveIndustry(data) {
    return apiClient.post('/sveIndustryType/save', data);
}

//修改行业
export function updateIndustry(data) {
    return apiClient.put('/sveIndustryType/update', data);
}

//删除行业
export function removeIndustry(id) {
    return apiClient.delete('/sveIndustryType/remove/' + id);
}

//获取行业详情
export function getIndustryInfo(id) {
    return apiClient.get('/sveIndustryType/getInfo/' + id);
}

//涉税关键词列表
export function taxKeywordList() {
    return apiClient.get('/sveTaxKeyword/list');
}

//涉税关键词分页
export function taxKeywordPage(data) {
    return apiClient.get('/sveTaxKeyword/page', {
        params: data,
    });
}

//添加涉税关键词
export function saveTaxKeyword(data) {
    return apiClient.post('/sveTaxKeyword/save', data);
}

//修改涉税关键词
export function updateTaxKeyword(data) {
    return apiClient.put('/sveTaxKeyword/update', data);
}

//删除涉税关键词
export function removeTaxKeyword(id) {
    return apiClient.delete('/sveTaxKeyword/remove/' + id);
}

//获取涉税关键词详情
export function getTaxKeywordInfo(id) {
    return apiClient.get('/sveTaxKeyword/getInfo/' + id);
}

//涉及税种列表
export function taxTypeList() {
    return apiClient.get('/sveTaxType/list');
}

//税种分页
export function taxTypePage(data) {
    return apiClient.get('/sveTaxType/page', {
        params: data,
    });
}

//添加税种
export function saveTaxType(data) {
    return apiClient.post('/sveTaxType/save', data);
}

//修改税种
export function updateTaxType(data) {
    return apiClient.put('/sveTaxType/update', data);
}

//删除税种
export function removeTaxType(id) {
    return apiClient.delete('/sveTaxType/remove/' + id);
}

//获取税种详情
export function getTaxTypeInfo(id) {
    return apiClient.get('/sveTaxType/getInfo/' + id);
}

//追问列表
export function followQuestionPage(data) {
    return apiClient.get('/sveTaxFollowQuestion/page', {
        params: data,
    });
}

//添加追问
export function saveFollowQuestion(data) {
    return apiClient.post('/sveTaxFollowQuestion/save', data);
}

//删除追问
export function removeFollowQuestion(id) {
    return apiClient.delete('/sveTaxFollowQuestion/remove/' + id);
}

//修改追问
export function updateFollowQuestion(data) {
    return apiClient.put('/sveTaxFollowQuestion/update', data);
}

//获取追问详情
export function getFollowQuestionInfo(id) {
    return apiClient.get('/sveTaxFollowQuestion/getInfo/' + id);
}

//获取追问父级链路
export function getFollowQuestionParentList(id) {
    return apiClient.get('/sveTaxFollowQuestion/listParent/' + id);
}

//导出追问数据
export function exportFollowQuestion(data) {
    return apiClient.post('/sveTaxFollowQuestion/export', data, {
        responseType: 'blob',
    });
}

//导出案例数据
export function exportCaseQuestion(data) {
    return apiClient.post('/sveTaxCase/export', data, {
        responseType: 'blob',
    });
}

// ==================== 专业团队 ====================

/**
 * 获取专业团队列表
 * GET /sveTaxExpertTeam/list
 */
export function expertTeamList() {
    return apiClient.get('/sveTaxExpertTeam/list');
}

// ==================== FAQ 问答测试 ====================

/**
 * 发送消息到已有对话
 * POST /adp/chat/send
 * body: { conversationId, message }
 */
export function sendChatMessage(data) {
    return apiClient.post('/adp/chat/send', data);
}

/**
 * 新建会话
 * POST /adp/conversation/create
 */
export function createConversation() {
    return apiClient.post('/adp/conversation/create');
}

/**
 * 查看会话信息
 * GET /adp/conversation/{conversationId}
 */
export function getConversation(conversationId) {
    return apiClient.get(`/adp/conversation/${conversationId}`);
}

/**
 * 获取会话列表
 * GET /adp/conversation/list?offset=0&limit=20
 */
export function getConversationList(params) {
    return apiClient.get('/adp/conversation/list', {
        params: {
            pageNumber: 1,
            pageSize: 20,
            ...params,
        },
    });
}

/**
 * 修改会话信息（标题）
 * PUT /adp/conversation/modify
 * body: { conversationId, title }
 */
export function modifyConversation(data) {
    return apiClient.put('/adp/conversation/modify', data);
}

/**
 * 删除会话
 * DELETE /adp/conversation/{conversationId}
 */
export function deleteConversationById(conversationId) {
    return apiClient.delete(`/adp/conversation/${conversationId}`);
}

/**
 * 获取会话历史消息
 * GET /adp/conversation/{conversationId}/messages?pageSize=20&recordId=&recordQueryDirection=
 */
export function getConversationMessages(conversationId, params) {
    return apiClient.get(`/adp/conversation/${conversationId}/messages`, {
        params: {
            pageSize: 20,
            ...params,
        },
    });
}

// ==================== 商品管理 ====================
// 以下接口统一带 silent：错误提示由页面/弹窗展示后端 msg，避免与拦截器重复弹出

//商品分页列表
export function commodityPage(data) {
    return apiClient.get('/sveProduct/page', {
        params: data,
        silent: true,
    });
}

//新增商品
export function saveCommodity(data) {
    return apiClient.post('/sveProduct/save', data, {
        silent: true,
    });
}

//编辑商品
export function updateCommodity(data) {
    return apiClient.put('/sveProduct/update', data, {
        silent: true,
    });
}

//删除商品（逻辑删除）
export function removeCommodity(id) {
    return apiClient.delete('/sveProduct/remove/' + id, {
        silent: true,
    });
}

// ==================== 支付管理 ====================
// 以下接口统一带 silent：错误提示由页面自行展示后端 msg，避免与拦截器重复弹出

//支付单分页列表
export function payOrderPage(data) {
    return apiClient.get('/payOrder/page', {
        params: data,
        silent: true,
    });
}

//支付单详情
export function payOrderInfo(id) {
    return apiClient.get('/payOrder/getInfo/' + id, {
        silent: true,
    });
}

//关闭支付单（后端会先核查微信侧真实状态再关单，POST）
export function closePayOrder(id) {
    return apiClient.post('/payOrder/close/' + id, null, {
        silent: true,
    });
}

//微信回调记录分页列表（列表不含 requestBody/headers 大字段）
export function payNotifyRecordPage(data) {
    return apiClient.get('/payNotifyRecord/page', {
        params: data,
        silent: true,
    });
}

//微信回调记录详情（含回调原始报文）
export function payNotifyRecordInfo(id) {
    return apiClient.get('/payNotifyRecord/getInfo/' + id, {
        silent: true,
    });
}

//业务通知记录分页列表
export function payBusinessNotifyPage(data) {
    return apiClient.get('/payBusinessNotify/page', {
        params: data,
        silent: true,
    });
}

//业务通知记录详情
export function payBusinessNotifyInfo(id) {
    return apiClient.get('/payBusinessNotify/getInfo/' + id, {
        silent: true,
    });
}

//手动重推业务通知（PUT，后端重置为待通知后由支付服务重试任务发送）
export function retryPayBusinessNotify(id) {
    return apiClient.put('/payBusinessNotify/retry/' + id, null, {
        silent: true,
    });
}

